// source: src/common/pipeline/stage_progress.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.pipeline.StageProgress', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.pipeline.StageProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.pipeline.StageProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.pipeline.StageProgress.displayName = 'proto.loupe.common.pipeline.StageProgress';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.pipeline.StageProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.pipeline.StageProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.pipeline.StageProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.pipeline.StageProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    stageName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    total: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    progressed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    added: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    pushed: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    lost: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    index: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.pipeline.StageProgress}
 */
proto.loupe.common.pipeline.StageProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.pipeline.StageProgress;
  return proto.loupe.common.pipeline.StageProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.pipeline.StageProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.pipeline.StageProgress}
 */
proto.loupe.common.pipeline.StageProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStageName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProgressed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAdded(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPushed(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLost(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.pipeline.StageProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.pipeline.StageProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.pipeline.StageProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.pipeline.StageProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStageName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getProgressed();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getAdded();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPushed();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLost();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string stage_name = 1;
 * @return {string}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getStageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setStageName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double total = 2;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double progressed = 3;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getProgressed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setProgressed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double added = 4;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getAdded = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setAdded = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double pushed = 5;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getPushed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setPushed = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double lost = 6;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getLost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setLost = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 index = 7;
 * @return {number}
 */
proto.loupe.common.pipeline.StageProgress.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.pipeline.StageProgress} returns this
 */
proto.loupe.common.pipeline.StageProgress.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.loupe.common.pipeline);
